export const ROOM_TERM_FIELDS = [
  ["commodity", "Commodity"], ["specification", "Grade / Specification"], ["quantity", "Quantity"],
  ["unit_price", "Unit price and price unit"], ["currency", "Currency"], ["total", "Contract total"],
  ["incoterms", "Incoterms"], ["named_place", "Named delivery place"], ["shipment_period", "Shipment period"],
  ["payment_terms", "Payment terms"], ["required_documents", "Required delivery documents"],
  ["additional_terms", "Additional agreed terms"],
];
export function emptyRoomTerms() { return Object.fromEntries(ROOM_TERM_FIELDS.map(([key]) => [key, ""])); }
export function roomTermsFromDeal(deal) {
  const goods = deal?.parameters?.goods || deal?.parameters?.product || {};
  const delivery = deal?.parameters?.delivery || deal?.parameters?.logistics || {};
  const payment = deal?.parameters?.payment || {};
  const join = (...values) => values.filter((value) => value !== undefined && value !== null && String(value).trim() !== "").join(" ");
  return { ...emptyRoomTerms(), commodity: goods.commodity || goods.product || "",
    specification: goods.specification || goods.grade_spec || "", quantity: join(goods.quantity, goods.unit),
    unit_price: join(goods.unit_price, goods.price_basis), currency: deal?.currency || goods.currency || "",
    total: String(deal?.total_value ?? ""), incoterms: delivery.incoterms || "", named_place: delivery.named_place || "",
    shipment_period: delivery.shipment_window || delivery.shipment_period || "",
    payment_terms: join(payment.method, payment.schedule, payment.balance),
  };
}
export function safeAuthDestination(from) {
  if (!from?.pathname?.startsWith("/app/") || from.pathname.includes("\\")) return "/app";
  return `${from.pathname}${from.search || ""}${from.hash || ""}`;
}
